import { FC } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Grid, Stack, Typography } from '@mui/material'

import {
  SidePanelObject,
  SidePanelElementProps,
  useSidePanelContext,
} from '@clara/layout-next'
import { Trans, useT } from '@clara/locale'
import { Button } from '@clara/ui'

import DisableFunctionality from 'assets/images/disable-functionality.svg'

const DisableFunctionalitySidepanel: FC<SidePanelElementProps> = () => {
  const { t } = useT('reimbursements')

  return (
    <Stack>
      <Stack sx={{ alignItems: 'center' }}>
        <img
          src={DisableFunctionality}
          alt="disable reimbursements functionality"
        />
      </Stack>
      <Typography
        variant="h2"
        sx={(theme) => ({
          mt: 4,
          fontWeight: 600,
          color: theme.palette.v3.content.high_emphasis,
        })}
      >
        {t('disable.sidepanel.title')}
      </Typography>
      <Typography
        variant="body2"
        sx={(theme) => ({
          mt: 1,
          fontWeight: 400,
          color: theme.palette.v3.content.medium_emphasis,
        })}
      >
        <Trans
          t={t}
          i18nKey="disable.sidepanel.description"
          components={{ br: <br /> }}
        />
      </Typography>
      <Typography
        variant="body1"
        sx={(theme) => ({
          mt: 4,
          fontWeight: 600,
          color: theme.palette.v3.content.high_emphasis,
        })}
      >
        {t('disable.sidepanel.continue')}
      </Typography>
    </Stack>
  )
}

const DisableFunctionalityFooter = () => {
  const { t } = useT('reimbursements')
  // const navigate = useNavigate()

  const sidePanel = useSidePanelContext()

  return (
    <Grid container direction="row" gap={2} justifyContent="center">
      <Button
        sx={(theme) => ({ minWidth: 200, marginTop: theme.spacing(1) })}
        variant="secondary"
        onClick={() => {
          sidePanel.prev()
        }}
      >
        {t('disable.sidepanel.no')}
      </Button>
      <Button
        sx={(theme) => ({ minWidth: 200, marginTop: theme.spacing(1) })}
        onClick={async () => {
          // TODO: add this redirection when the flow is completed
          // navigate('/invoices')
          sidePanel.panels = []
          sidePanel.onClose()
        }}
      >
        {t('disable.sidepanel.yes')}
      </Button>
    </Grid>
  )
}

export const getDisableFunctionalitySidePanel = () =>
  [
    {
      children: [
        {
          element: <DisableFunctionalitySidepanel />,
          footer: <DisableFunctionalityFooter />,
        },
      ],
    },
  ] as SidePanelObject[]
